/*       */

import { gql } from '@apollo/client';

export default gql`
    query userReferencesQuery($includeInactive: Boolean = true) {
        result: userReferences(includeInactive: $includeInactive) {
            id
            name
            image
            username
            active
        }
    }
`;
